import React, { Component, createRef } from 'react';
import { Tooltip } from '@mui/material';
import { TipTapEditor } from '../TipTap';

/**
 * MentionEditor - Minimal text field with placeholder autocomplete
 * 
 * No toolbar, outputs plain text, supports $ placeholders.
 * Used for simple text fields that need placeholder insertion.
 */
class MentionEditor extends Component {
  editorRef = createRef();

  constructor(props) {
    super(props);
    this.state = {
      content: this.normalizeContent(this.props.text),
    };
  }

  normalizeContent(text) {
    let content = text;
    if (content) {
      content = content.toString();
      // Handle newlines
      if (content.includes('"\\n"')) {
        content = content.replace(/\\n/g, '\n');
      } else {
        content = content.replace(/(?:\r\n|\r|\n\n)/g, '<br>');
        content = content.replace(/(?:\n)/g, '');
      }
    } else {
      content = '';
    }
    return content;
  }

  componentDidUpdate(prevProps) {
    if (this.props.text !== prevProps.text) {
      this.setState({
        content: this.normalizeContent(this.props.text),
      });
    }

    // Handle placeholder insertion via props
    const { placeholders } = this.props;
    if (prevProps.placeholders === null || prevProps.placeholders === undefined) {
      if (placeholders !== undefined && placeholders !== null) {
        this.insertPlaceholder(placeholders[placeholders.length - 1]);
        return;
      }
    }
    if (placeholders && placeholders.length !== prevProps.placeholders?.length) {
      this.insertPlaceholder(placeholders[placeholders.length - 1]);
    }
  }

  insertPlaceholder = (placeholder) => {
    if (placeholder && this.editorRef.current) {
      this.editorRef.current.insertPlaceholder(placeholder);
      if (this.props.onFocus) {
        this.props.onFocus();
      }
    }
  };

  handleChange = (value) => {
    this.setState({ content: value });
  };

  handleBlur = (value) => {
    // Clean up the value
    let cleanValue = value;
    cleanValue = cleanValue.replaceAll('&nbsp;', ' ');
    
    // Handle newlines
    if (cleanValue.includes('"\\n"')) {
      cleanValue = cleanValue.replace(/\n/g, '\\n');
    }

    if (this.props.onChange) {
      this.props.onChange(cleanValue);
    }
  };

  handleFocus = () => {
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  render() {
    const { error, helperText, placeholder, minHeight, availablePlaceholders, className, style, variant } = this.props;
    const { content } = this.state;

    return (
      <Tooltip 
        placement="bottom" 
        title='Type "$" to view and insert placeholders'
        enterDelay={1200}
        enterNextDelay={1200}
      >
        <div onClick={this.handleFocus} style={style} className={className}>
          <TipTapEditor
            ref={this.editorRef}
            value={content}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            onFocus={this.handleFocus}
            showToolbar={false}
            stripHtml={true}
            triggerChars={['$']}
            availablePlaceholders={availablePlaceholders}
            placeholder={placeholder || ''}
            minHeight={minHeight || '21px'}
            variant={variant || 'minimal'}
            error={error}
            helperText={helperText}
          />
        </div>
      </Tooltip>
    );
  }
}

export default MentionEditor;
